import { h, Component } from 'preact';
import * as BaseComp from 'components/bolt/youtube/youtube.js';
import { waitForOneTrust } from 'utils/gdpr/oneTrust';
import { accessNested } from 'utils/utils';
import Store from 'store/store';

export default class Youtube extends BaseComp.default {
	constructor(props) {
		super(props);
		waitForOneTrust().then(() => this.forceUpdate());
	}

	async componentDidMount() {
		super.componentDidMount?.();
		await waitForOneTrust();
		if (this.blocked) {
			this.getShowCookieSettingsFunction()?.();
		}
	}

	shouldBlockRender() {
		if (typeof window === 'undefined' || !window.consentHelper) {
			return false;
		}
		return !window.consentHelper.isSDKInitialized() || !window.consentHelper.getVendorConsent('youtube');
	}

  getShowCookieSettingsFunction() {
    return () => {
      if (window.consentHelper) {
        const store = Store.get() || {};
        const colors = store?.appData?.styling?.variables;
        const buttonStyles = {
          'background-color': colors?.primaryColor + ' !important',
          'color': colors?.primaryTextColor + ' !important',
          'border': colors?.primaryColor + ' !important',
        };
        const backgroundStyles = {
          'background': colors?.secondaryColor + ' !important',
          'color': colors?.secondaryTextColor + ' !important',
        };
        const backgroundStyles2 = {
          'background': 'rgba(13,13,13,0.7)' + ' !important',
          'color': colors?.white + ' !important',
        };
        window.consentHelper.consentStyles['#consent-dialog, #consent-dialog-header, .consent-dialog-content'] = backgroundStyles;
        window.consentHelper.consentStyles['.detail-row'] = backgroundStyles2;
        window.consentHelper.consentStyles['.btn.btn-primary, #consent-dialog .switch input[type=checkbox]:checked+.slider'] = buttonStyles;

        return window.consentHelper.getConsent('youtube');
      }
      return false;
    };
  }
}